module.exports = __webpack_public_path__ + "static/media/logo.f5b83ab4.svg";